module.exports = __webpack_public_path__ + "img/04.90e2e4f2.webp";